<div class="notification-content">
    <div class="close-icon position-absolute">
        <wz-icon [customClass]="'blank-icon click-enabled'" [iconClass]="'icon-16'" (click)="closeSnack(0)" [name]="'close'"></wz-icon>
    </div>
    <div class="d-flex h-min-90">
        <ng-container [ngSwitch]="data?.action">
            <ng-container *ngSwitchCase="'success'" [ngTemplateOutlet]="success"></ng-container>
            <ng-container *ngSwitchCase="'error'" [ngTemplateOutlet]="error"></ng-container>
            <ng-container *ngSwitchCase="'warning'" [ngTemplateOutlet]="warning"></ng-container>
        </ng-container> 
        <div class="notification-body psl-2 psr-2 py-3">
            <div class="d-flex justify-content-between mab-5">
                <span class="col-gray-600 font-wight-5">{{data?.title}}</span>
            </div>
            <span class="mt-2 notification-text">{{data?.content}}</span>
        </div>
    </div>
</div>

<!-- success notification -->
<ng-template #success>
    <div class="w-px-60 ps-1 pt-1 icon-container">
        <div class="action-icon success d-flex justify-content-center mt-1">
            <img src="assets\images\icons\notification-success.svg">
        </div>
        <img class="notification-bg" src="assets\images\icons\notification-bg-success.svg">
    </div>
</ng-template>

<!-- error notification -->
<ng-template #error>
    <div class="w-px-60 ps-1 pt-1 icon-container">
        <div class="action-icon error-icon d-flex justify-content-center mt-1">
            <img src="assets\images\icons\notification-error.svg">
        </div>
        <img class="notification-bg" src="assets\images\icons\notification-bg-error.svg">
    </div>
</ng-template>

<!-- warning notification -->
<ng-template #warning>
    <div class="w-px-60 ps-1 pt-1 icon-container">
        <div class="action-icon warning d-flex justify-content-center mt-1">
            <img src="assets\images\icons\question-mark.svg">
        </div>
        <img class="notification-bg" src="assets\images\icons\notification-bg-warning.svg">
    </div>
</ng-template>